import CareerJobs from './career-jobs';

export default class CareerJobsDesktop extends CareerJobs {
    constructor(...args) {
        super(...args);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/career/jobs/career-jobs.desktop.js